export enum VirtualPosSortType {
    Id,
    Name,
    IsDeleted
}
